import React from "react";
import { compose, branch, renderComponent, lifecycle } from "recompose";
import { connect } from "react-redux";
import { actions } from "../../modules/settings";
import { isEmpty } from "lodash";
import SelectRole from "../../components/SelectRole";
import { actions as contractActions } from "../../modules/contracts";
import { actions as dealerActions } from "../../modules/dealers";
import { actions as customerActions } from "../../modules/customers";

const isCustomerAndStaff = ({ user, role }) =>
  user && (!isEmpty(user.staff) && !isEmpty(user.customers)) && !role;

const nonOptimalStates = states =>
  compose(...states.map(state => branch(state.when, state.render)));

const SelectRoleAdvice = props => {
  return (
    <div>
      <div style={{ marginBottom: 30 }}>
        <SelectRole />
      </div>
      <p>You can change your role again in the settings section.</p>
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user,
  role: state.settings.role,
  dealers: state.auth?.user?.dealer_for_contact || [],
  customers: state.auth?.user?.customer_for_contact || []
});

const mapActionCreators = {
  setRole: actions.setRole,
  fetchContractsWithContact: contractActions.fetchContractsWithContact,
  fetchContactDealers: dealerActions.fetchContactDealers,
  setCurrentDealer: dealerActions.setCurrentDealer,
  fetchContactCustomers: customerActions.fetchContactCustomers,
  setCurrentCustomer: customerActions.setCurrentCustomer
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  lifecycle({
    componentDidMount() {
      const {
        user,
        setRole,
        dealers,
        customers,
        fetchContractsWithContact,
        setCurrentDealer,
        setCurrentCustomer
      } = this.props;
      if (user) {
        if (
          user.contact_for &&
          user.dealer_for_contact &&
          user.customer_for_contact &&
          (user.contact_for.length > 0 ||
            user.dealer_for_contact.length > 0 ||
            user.customer_for_contact.length > 0)
        ) {
          setRole("contact");
          fetchContractsWithContact();
          setCurrentDealer(dealers[0]);
          setCurrentCustomer(customers[0]);
        } else if (
          (isEmpty(user.staff) && isEmpty(user.customers)) ||
          (!isEmpty(user.staff) && isEmpty(user.customers))
        ) {
          setRole("staff");
        } else if (isEmpty(user.staff) && !isEmpty(user.customers)) {
          setRole("customer");
        }
      }
    }
  }),
  nonOptimalStates([
    { when: isCustomerAndStaff, render: renderComponent(SelectRoleAdvice) }
  ])
);
